//import styles from "./_image-slider.scss";
import ScrollReveal from "scrollreveal";
import Swiper from "swiper/bundle";
export function imageGallerySlider() {
  const projectsSlider = new Swiper(".image-gallery__inner", {
    slidesPerView: 1,
    centeredSlides: false,
    autoHeight: true,
    loop: false,
    direction: "horizontal",
    navigation: {
      nextEl: ".image-gallery__swiper-button-next",
      prevEl: ".image-gallery__swiper-button-prev",
    },
  });
}

export function categoryPostsSlider() {
  //each .category-posts__slider

  const categoryPostsSliderElements = document.querySelectorAll(
    ".category-posts__slider"
  );
  if (categoryPostsSliderElements.length === 0) {
    return;
  }
  // Initialize Swiper for each element
  categoryPostsSliderElements.forEach((sliderElement) => {
    //get data-attribute data-category
    const category = sliderElement.getAttribute("data-category");
    new Swiper(sliderElement, {
      slidesPerView: 1,
      centeredSlides: false,
      autoHeight: true,
      spaceBetween: 30,
      loop: false,
      direction: "horizontal",
      navigation: {
        nextEl: ".category-posts__swiper-button-next-" + category,
        prevEl: ".category-posts__swiper-button-prev-" + category,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 1,
        },
      },
    });
  });
}

export function heroSlider() {
  var sr = ScrollReveal();
  sr.clean(".testreveal");

  const heroSlider = new Swiper(".hero-slider__inner", {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: true,
    },
    direction: "horizontal",
    navigation: {
      nextEl: ".hero-slider__swiper-button-next",
      prevEl: ".hero-slider__swiper-button-prev",
    },
  });
}
